import { isValidNumber } from "libphonenumber-js";

// patron del RFC, persona fisica
const rfc_pattern_pf =
  "^(([A-ZÑ&]{4})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
  "(([A-ZÑ&]{4})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
  "(([A-ZÑ&]{4})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
  "(([A-ZÑ&]{4})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$";

// patron del RFC, persona moral
const rfc_pattern_pm =
  "^(([A-ZÑ&]{3})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
  "(([A-ZÑ&]{3})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
  "(([A-ZÑ&]{3})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
  "(([A-ZÑ&]{3})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$";

const rfcValidation = value => {
  //   const parts_pf = /\/(.*)\/(.*)/.exec(rfc_pattern_pf);
  //   const parts_pm = /\/(.*)\/(.*)/.exec(rfc_pattern_pm);
  //   console.log(new RegExp(rfc_pattern_pf), rfc_pattern_pm);
  const regexPF = new RegExp(rfc_pattern_pf);
  const regexPM = new RegExp(rfc_pattern_pm);

  return regexPF.test(value) || regexPM.test(value);
};

const phoneValidation = (phone_number, country = "MX") => {
  return isValidNumber(phone_number, country);
};

export { rfcValidation, phoneValidation };



// WEBPACK FOOTER //
// ./src/Utils/validation-patterns.js